import { Component, EventEmitter, HostListener, ViewChild } from '@angular/core';
import { addMinutes, differenceInMinutes } from 'date-fns';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Operation } from '../../bo/operation';
import { Operator } from '../../bo/operator';
import { Rotation } from '../../bo/rotation';
import { TypeOperation } from '../../bo/typeOperation';
import { Equipment } from 'src/app/bo/equipment';

@Component({
  selector: 'app-operation-modale',
  templateUrl: './operation-modale.component.html',
  styleUrls: ['./operation-modale.component.scss'],
  standalone: false
})
export class OperationModaleComponent {
  @ViewChild('modalConfirmSuppr') modalConfirmSuppr: ModalDirective;
  @ViewChild('modalConfirmCancel') modalConfirmCancel: ModalDirective;
  operation: Operation;
  typeOpSelectionne: TypeOperation;
  tabTypeOp: TypeOperation[];
  equipementsSelectionnes: Equipment[];
  tabEquipements: Equipment[];
  tabOperateurs: Operator[];
  operateurSelectionne: Operator;
  rotation: Rotation;
  estModif: boolean;
  operationSauv: Operation;
  operationModifiee = new EventEmitter<boolean>();
  fermetureModale = new EventEmitter<boolean>();
  typeNonValide = false;
  erreur = false;
  siteId: number;
  modalSupprAffichee: boolean;

  dateDebut: Date;
  dateFin: Date;
  duree: Date;

  constructor() { }

  @HostListener('window:keydown.esc', ['$event'])
  onEsc(event: any): void {
    if (event.keyCode === 27) {
      event.preventDefault();
    }

    if (!this.modalSupprAffichee)
      this.showModalCancel();
  }

  ngOnInit() {

    if (this.estModif && this.operation) {
      this.operationSauv = Object.assign('', this.operation);

      if (null !== this.operation.timeDebut && undefined !== this.operation.timeDebut) {
        this.dateDebut = new Date(this.operation.timeDebut);
      }
      else {
        this.dateDebut = new Date(this.rotation.date);
      }
      if (this.operation.duree > 0) {
        // Convert seconds to hours and minutes without moment.js
        const totalSeconds = this.operation.duree;
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        this.duree = new Date(0, 0, 0, hours, minutes);
      }
      else {
        this.duree = undefined;
        this.dateFin = undefined;
      }
      this.operateurSelectionne = this.tabOperateurs.find(o => o.operatorId == this.operation.operatorId);
    }
    else if (!this.estModif) {
      this.duree = undefined;
      this.dateFin = undefined;
      this.operation = new Operation();
      this.equipementsSelectionnes = [];
      this.typeOpSelectionne = null;
      this.operateurSelectionne = null;
    }
  }

  onSubmit() {
    if (this.validationFormulaire()) {
      // Operation.TypeSelectionne
      if (this.typeOpSelectionne.typeOperationId)
        this.operation.typeOperation = this.typeOpSelectionne;
      else {
        this.operation.typeOperation = new TypeOperation();
        this.operation.typeOperation.typeOperationId = -1;
        this.operation.typeOperation.nom = this.typeOpSelectionne.nom;
        this.operation.typeOperation.siteId = this.siteId;
      }
      // Operation.Equipements/EquipementsFormates
      this.operation.equipments = [];
      this.operation.equipementsFormates = '';
      this.equipementsSelectionnes.forEach(equipement => {
        let _equipement: Equipment = {
          equipementId: equipement.equipementId && equipement.equipementId > 0 ? equipement.equipementId : -1,
          name:equipement.name,
          siteId:equipement.siteId,
        }
        this.operation.equipments.push(_equipement);
        this.operation.equipementsFormates += _equipement.name + '; ';
      });

      //operateur
      if (null !== this.operateurSelectionne && undefined !== this.operateurSelectionne) {
        this.operation.operatorId = this.operateurSelectionne.operatorId;
        this.operation.operator = this.operateurSelectionne;
      }

      //date debut et durée:
      this.operation.timeDebut = this.dateDebut;
      if (undefined !== this.duree) {
        this.operation.duree = this.duree.getHours() * 3600 + this.duree.getMinutes() * 60;
      }

      if (!this.rotation.operations)
        this.rotation.operations = [];
      if (!this.operation.duree)
        this.operation.duree = 0;

      //control le bon site de l'opération
      this.operation.siteId = this.siteId;

      if (this.estModif) {
        let index: number;
        if (this.operation.randomId)
          index = this.rotation.operations.findIndex(o => o.randomId == this.operation.randomId);
        else
          index = this.rotation.operations.findIndex(o => o.operationId == this.operation.operationId);
        // Suppression de l'item
        this.rotation.operations.splice(index, 1);
        // Remplacement par la modification
        this.rotation.operations.splice(index, 0, this.operation);
      } else {
        this.operation.randomId = Math.trunc(Math.random() * 1000000 + 1);
        this.rotation.operations.push(this.operation);
      }

      this.fermetureModale.emit(true);
      this.fermetureModale.complete();
    }
  }

  validationFormulaire() {
    this.typeNonValide = null === this.typeOpSelectionne || undefined === this.typeOpSelectionne;

    return !this.typeNonValide;
  }

  showModalCancel() {
    if (this.diff())
      this.modalConfirmCancel.show();
    else {
      this.fermetureModale.emit(false);
      this.fermetureModale.complete();
    }
  }

  showModalSuppr() {
    this.modalConfirmSuppr.show();
    this.modalSupprAffichee = true;
  }

  hideModalSuppr() {
    this.modalConfirmSuppr.hide();
    this.modalSupprAffichee = false;
  }

  diff() {
    if (this.estModif) {
      let equipementsChanges = false;
      if ((!this.operation.equipments && this.equipementsSelectionnes && this.equipementsSelectionnes.length > 0) ||
        (this.operation.equipments && this.operation.equipments.length !== this.equipementsSelectionnes.length))
        equipementsChanges = true;
      else {
        this.operation.equipments.forEach(equipement => {
          if (this.equipementsSelectionnes.find(o => o.equipementId == equipement.equipementId
            
          ) == undefined)
            equipementsChanges = true;
        });
      }
      return (this.operationSauv.typeOperation.typeOperationId !== this.typeOpSelectionne.typeOperationId ||
        this.operationSauv.duree !== this.operation.duree ||
        equipementsChanges);
    } else
      return (this.typeOpSelectionne || this.operation.duree || this.equipementsSelectionnes.length > 0);
  }

  delete() {
    let index = this.rotation.operations.findIndex(o => o.operationId == this.operation.operationId);
    if (index > -1)
      this.rotation.operations.splice(index, 1);
    this.fermetureModale.emit(true);
    this.fermetureModale.complete();
  }

  annulModif() {
    this.fermetureModale.emit(false);
    this.fermetureModale.complete();
  }

  changeDebut(val: any) {
    if (undefined !== this.duree) {
      const durationMinutes = this.duree.getHours() * 60 + this.duree.getMinutes();
      this.dateFin = addMinutes(new Date(val), durationMinutes);
    }
    this.dateDebut = val;
  }

  changeDuree(val: any) {
    if (val !== this.duree) {
      const durationMinutes = val.getHours() * 60 + val.getMinutes();
      this.dateFin = addMinutes(new Date(this.dateDebut), durationMinutes);
      this.duree = val;
    }
  }

  changeFin(val: any) {
    if (undefined == this.dateFin) {
      this.dateFin = this.dateDebut;
      this.duree = new Date(0, 0, 0, 0, 0);
    }
    else if (this.dateFin !== val) {
      const diffMinutes = differenceInMinutes(new Date(val), new Date(this.dateDebut));
      
      // Prevent negative duration: end date must be after start date
      if (diffMinutes < 0) {
        console.warn('End date cannot be before start date. Duration set to zero.');
        this.duree = new Date(0, 0, 0, 0, 0);
        this.dateFin = this.dateDebut;
        return;
      }
      
      const hours = Math.floor(diffMinutes / 60);
      const minutes = diffMinutes % 60;
      this.duree = new Date(0, 0, 0, hours, minutes);
      this.dateFin = val;
    }
  }
}
